import { untrack } from "svelte";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function useFullPathHrefAccessor(
  hostElement: HTMLElement & { base64Href?: string },
  getHref: () => string | undefined,
  setHref: (value: string) => unknown,
): void {
  Object.defineProperty(
    untrack(() => hostElement),
    "href",
    {
      get() {
        let href = untrack(getHref);
        const { base64Href } = untrack(() => hostElement);

        href ??= base64Href ? atob(base64Href) : undefined;
        if (!href) return href; /*                */

        /*                                           */
        const a = document.createElement("a");
        a.href = href; /*       */

        /*                           */
        return a.href;
      },
      set: (val) => {
        setHref(val);
        /*                           */
        const host = untrack(() => hostElement);
        if (host.base64Href) {
          host.base64Href = btoa(val);
        }
      },
      configurable: true,
    },
  );
}
